import { createContext } from 'react';
const FullstoryBrowserContext = createContext(null);
export default FullstoryBrowserContext;
//# sourceMappingURL=fullstory-browser.js.map